import { useEffect, useRef, RefObject } from 'react';

export const useClickOutside = (
  ref: RefObject<HTMLElement | null>,
  onClose: () => void,
  active: boolean = true
) => {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!active) return;

    const listener = (event: PointerEvent | MouseEvent | TouchEvent) => {
      const el = ref.current;
      if (!el || el.contains(event.target as Node)) {
        return;
      }
      onCloseRef.current();
    };

    const hasPointer = typeof window !== 'undefined' && 'PointerEvent' in window;

    if (hasPointer) {
      document.addEventListener('pointerdown', listener, true);
    } else {
      document.addEventListener('mousedown', listener, true);
      document.addEventListener('touchstart', listener, true);
    }

    return () => {
      if (hasPointer) {
        document.removeEventListener('pointerdown', listener, true);
      } else {
        document.removeEventListener('mousedown', listener, true);
        document.removeEventListener('touchstart', listener, true);
      }
    };
  }, [ref, active]);
};
